import { ThunkType } from "../../../../../core/store/reducers";
import { setData } from "../tradeByBrokersDataSlice";
import getTradeByBrokersDataApi from "../api/getTradeByBrokersData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.reports.exchbusiness.tradeByBrokers;

  const pagedTrades = await dispatch(getTradeByBrokersDataApi(user, filter));

  dispatch(setData(pagedTrades || []));
};
